import { get, post } from "../GenericServices";

const Project = {
  listProject: (queryString) => {
    return get(`project?${queryString}`);
  },
  getProject: (id) => {
    return get(`project/${id}`);
  },
  saveProject: (data) => {
    return post(`project`, data);
  },
  listSupportPm: () => {
    return get(`project/user-support-pm`);
  },
  getUserProjects: (queryString) => {
    return get(`project/user-projects?${queryString}`);
  },
  getSupportPm: () => {
    return get(`project/user-support-pm`);
  },
  getPm: () => {
    return get(`project/user-pm`);
  },
  getClients: (queryString) => {
    return get(`project/client-portal?${queryString}`);
  },
  projectsManangementlist: (queryString) => {
    return get(`project/list?${queryString}`);
  },
  projectsList: (queryString) => {
    return get(`project?${queryString}`);
  },
  getInfoProject: (id) => {
    return get(`project/${id}`);
  },
  getContractualRevenues: (id) => {
    return get(`project/${id}/contractual-revenue`);
  },
  getDocumentList: (id) => {
    return get(`project/${id}/document`);
  },
  saveProjectDocument: (id, queryString, file) => {
    return post(`project/${id}/document?${queryString}`, file);
  },
  getSocieties: (queryString) => {
    return get(`project/society?${queryString}`);
  },
};

export default Project;
